import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  ['WebformElementWebformDocumentFile', 'WebformElementManagedFile'],
  (item) => {
    const noFilesIcon =
      '<svg style="width: 20px; height: 20px" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2.50169 8.49831H8.49831V2.50169C8.49831 1.66967 9.16798 1 10 1C10.832 1 11.5017 1.66967 11.5017 2.50169V8.49831H17.4983C18.3303 8.49831 19 9.16798 19 10C19 10.832 18.3303 11.5017 17.4983 11.5017H11.5017V17.4983C11.5017 18.3303 10.832 19 10 19C9.16798 19 8.49831 18.3303 8.49831 17.4983V11.5017H2.50169C1.66967 11.5017 1 10.832 1 10C1 9.16798 1.66967 8.49831 2.50169 8.49831Z"></path></svg>'
    const fileRemoveIcon =
      '<svg xmlns="http://www.w3.org/2000/svg" style="width: 20px; height: 20px" viewBox="0 0 12 16"><path d="M10,12.5c-.13,0-.26-.05-.35-.15L1.65,4.35c-.2-.2-.2-.51,0-.71,.2-.2,.51-.2,.71,0L10.35,11.65c.2,.2,.2,.51,0,.71-.1,.1-.23,.15-.35,.15Z" fill="currentColor"></path><path d="M2,12.5c-.13,0-.26-.05-.35-.15-.2-.2-.2-.51,0-.71L9.65,3.65c.2-.2,.51-.2,.71,0,.2,.2,.2,.51,0,.71L2.35,12.35c-.1,.1-.23,.15-.35,.15Z" fill="currentColor"></path></svg>'

    const accept = (item.element.extensions || '')
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean)
      .map((v) => '.' + v)
      .join(',')

    return {
      $formkit: 'file',
      noFilesIcon,
      fileRemoveIcon,
      multiple: item.element.cardinality !== 1,
      accept,
    }
  },
)
